import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeAlert } from "./../../reducers/userConfigSlice";
import { TbAlertCircle, TbCircleCheck } from "react-icons/tb";
import "./style.css";

const ALERT_DURATION = 3000;

const AlertIcon = ({ type }) => {
  if (type === "error" || type === "warning") {
    return <TbAlertCircle />;
  }

  return <TbCircleCheck />;
};

const AlertComponent = ({ alert, onRemove }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onRemove(alert.id), 300);
    }, ALERT_DURATION);

    return () => clearTimeout(hideTimeout);
  }, [alert.id, onRemove]);

  const alertType = ["success", "warning", "error"].includes(alert.type) ? alert.type : "success";

  return (
    <div className={`alert-banner alert-${alertType} ${isVisible ? "show" : "hide"}`}>
      <div className="alert-banner-body">
        <div className="message-icon">
          <AlertIcon type={alertType} />
        </div>
        <div>
          <div className="message-title">{alert.title}</div>
          <div className="message-description">{alert.message}</div>
        </div>
      </div>
      <div className="progress-line" />
    </div>
  );
};

export const Alert = () => {
  const dispatch = useDispatch();
  const alerts = useSelector((state) => state.aplicationConfig.userConfig.alerts);
  const [activeAlerts, setActiveAlerts] = useState([]);

  useEffect(() => {
    setActiveAlerts((currentAlerts) => {
      const currentIds = new Set(currentAlerts.map((alert) => alert.id));
      const newAlerts = alerts.filter((alert) => !currentIds.has(alert.id));
      return newAlerts.length > 0 ? [...currentAlerts, ...newAlerts] : currentAlerts;
    });
  }, [alerts]);

  const removeActiveAlert = React.useCallback(
    (alertId) => {
      dispatch(removeAlert(alertId));
      setActiveAlerts((currentAlerts) => currentAlerts.filter((alert) => alert.id !== alertId));
    },
    [dispatch]
  );

  return (
    <div className="alert-container">
      {activeAlerts.map((alert) => (
        <AlertComponent key={alert.id} alert={alert} onRemove={removeActiveAlert} />
      ))}
    </div>
  );
};
